<div class="page-container">
    <header class="page-header">
        <div class="header-left">
            <h1>Reports</h1>
            <p class="subtitle">View staff reports and activities</p>
        </div>
        <div class="header-actions">
            <button (click)="showFilters = !showFilters" class="btn-filter-toggle" [class.active]="showFilters">
                <i class="fa" [ngClass]="showFilters ? 'fa-filter' : 'fa-filter'"></i>
                {{ showFilters ? 'Hide Filters' : 'Show Filters' }}
            </button>
        </div>
    </header>

    <div class="filter-bar" *ngIf="showFilters">
        <div class="filter-group">
            <label>Staff Member</label>
            <select [(ngModel)]="selectedUserName" (change)="applyFilters()" class="filter-select">
                <option value="">All Users</option>
                <option *ngFor="let name of allUserNames" [value]="name">{{ name }}</option>
            </select>
        </div>

        <div class="filter-group">
            <label>Project</label>
            <select [(ngModel)]="selectedProjectId" (change)="applyFilters()" class="filter-select">
                <option value="">All Projects</option>
                <option *ngFor="let project of allProjects" [value]="project.id">{{ project.name }}</option>
            </select>
        </div>

        <div class="filter-group">
            <label>Start Date</label>
            <input type="date" [(ngModel)]="startDate" (change)="applyFilters()" class="filter-input">
        </div>

        <div class="filter-group">
            <label>End Date</label>
            <input type="date" [(ngModel)]="endDate" (change)="applyFilters()" class="filter-input">
        </div>

        <div class="filter-actions">
            <button (click)="clearFilters()" class="btn-secondary">Clear Filters</button>
        </div>
    </div>

    <div *ngIf="errorMessage" class="error-alert">
        {{ errorMessage }}
    </div>

    <div *ngIf="isLoading && logs.length === 0" class="loading-state">
        <div class="spinner"></div>
        <p>Loading reports...</p>
    </div>

    <div *ngIf="!isLoading && filteredLogs.length === 0" class="empty-state">
        <p>No reports found matching your criteria.</p>
    </div>

    <div *ngIf="!isAdmin && filteredLogs.length > 0" class="table-container">
        <table class="premium-table">
            <thead>
                <tr>
                    <th>Staff Member</th>
                    <th>Date</th>
                    <th>Project</th>
                    <th>Duration</th>
                    <th>Description</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let log of filteredLogs" (click)="openDetail(log.id)" class="clickable-row">
                    <td data-label="Staff Member">
                        <div class="user-cell">
                            <div class="avatar">{{ (log.userName || 'U')?.charAt(0) | uppercase }}
                            </div>
                            <div class="info">
                                <span class="name">{{ log.userName || 'Unknown User' }}</span>
                            </div>
                        </div>
                    </td>
                    <td data-label="Date">{{ log.date | date:'mediumDate' }}</td>
                    <td data-label="Project"><strong>{{ log.projectName || 'Unknown Project' }}</strong></td>
                    <td data-label="Duration">
                        <span class="hours-badge">{{ log.displayDuration }}</span>
                    </td>
                    <td data-label="Description">
                        <div class="description-cell">{{ log.description }}</div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Loading more indicator (for infinite scroll) -->
    <div class="loading-more-container" *ngIf="isLoadingMore">
        <div class="spinner-small"></div>
        <p>Loading more reports...</p>
    </div>

    <!-- End of data indicator -->
    <div class="end-of-data" *ngIf="!hasMoreData && !isLoading && logs.length > 0">
        <p>No more reports to load</p>
    </div>

    <!-- Timeline View for Admins -->
    <div *ngIf="isAdmin && timelineData.length > 0" class="timeline-container">
        <div class="timeline-line"></div>
        <div *ngFor="let day of timelineData" class="timeline-item">
            <div class="timeline-dot" (click)="toggleDate(day)" [class.active]="day.expanded">
                <div class="inner-dot"></div>
            </div>
            <div class="timeline-content">
                <div class="date-header" (click)="toggleDate(day)">
                    <h3>{{ day.date | date:'fullDate' }}</h3>
                    <span class="expand-icon"><i class="fa"
                            [ngClass]="day.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i></span>
                </div>

                <div class="user-list" *ngIf="day.expanded">
                    <div *ngFor="let user of day.users" class="user-group-card" (click)="toggleUser(user, $event)">
                        <div class="user-header" [style.background]="user.color + '15'"
                            [style.border-left]="'4px solid ' + user.color">
                            <div class="user-info">
                                <div class="avatar-small" [style.background]="user.color">{{ user.avatarLetter }}</div>
                                <div class="user-details">
                                    <div class="user-name">{{ user.name }}</div>
                                    <div class="project-chips">
                                        <div *ngFor="let proj of user.projects" class="project-chip">
                                            <span class="chip-name">{{ proj.name }}</span>
                                            <span class="chip-duration">{{ proj.duration }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="user-meta">
                                <i class="fa" [ngClass]="user.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                            </div>
                        </div>

                        <div class="user-tasks" *ngIf="user.expanded" (click)="$event.stopPropagation()">
                            <div *ngFor="let log of user.logs" class="task-item">
                                <div class="task-project">{{ log.projectName }}</div>
                                <div class="task-desc">{{ log.description }}</div>
                                <div class="task-duration">{{ log.displayDuration }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Log Detail Modal -->
<div *ngIf="showModal" class="modal-overlay" (click)="closeModal()">
    <div class="modal-card detail-modal" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h3>Time Log Details</h3>
            <button (click)="closeModal()" class="close-btn">
                <i class="fa fa-times"></i>
            </button>
        </div>
        <div class="modal-body" *ngIf="selectedLog">
            <div class="detail-grid">
                <div class="detail-item">
                    <label>Staff Member</label>
                    <div class="value-with-avatar">
                        <div class="avatarSmall">{{ (selectedLog.staffName || selectedLog.userName || 'U').charAt(0) |
                            uppercase }}</div>
                        <span>{{ selectedLog.staffName || selectedLog.userName || 'Unknown User' }}</span>
                    </div>
                </div>
                <div class="detail-item">
                    <label>Project</label>
                    <div class="value">{{ selectedLog.projectName || 'Unknown Project' }}</div>
                </div>
                <div class="detail-item">
                    <label>Date</label>
                    <div class="value">{{ selectedLog.date | date:'fullDate' }}</div>
                </div>
                <div class="detail-item">
                    <label>Duration</label>
                    <div class="value"><span class="hours-badge">{{ selectedLog.displayDuration }}</span></div>
                </div>
            </div>
            <div class="detail-item full-width mt-3">
                <label>Description</label>
                <div class="description-box">{{ selectedLog.description }}</div>
            </div>
        </div>
        <div class="modal-footer">
            <button (click)="closeModal()" class="btn-primary">Close</button>
        </div>
    </div>
</div>